export default __webpack_public_path__ + "static/media/Ads-Grader-Logo-White.7bdf4a1f.png";